import {FC} from "react";
import { IStoreModel } from "../../models/StoreModel";
import moment from "moment";

type TProps = {
  storeData?: IStoreModel
}
const SvExpiresBlock: FC<TProps> = ({storeData}) => {
  const formatDateTime = (dateString: string | undefined) => {
    if (dateString) {
      return moment(dateString).format('DD-MM-YYYY H:m')
    }
    return dateString
  }
  return <div className="row">
    <div className="col-12 col-md-6 col-lg-4 mb-2">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title mb-3">Chữ ký số token</h5>
          <p className="mb-0">Đăng ký: {formatDateTime(storeData?.es_token_registed_at)}</p>
          <p className="">Hết hạn: {formatDateTime(storeData?.es_token_expired_at)}</p>
        </div>
      </div>
    </div>
    <div className="col-12 col-md-6 col-lg-4 mb-2">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title mb-3">Chữ ký số HSM</h5>
          <p className="mb-0">Đăng ký: {formatDateTime(storeData?.es_hsm_token_registed_at)}</p>
          <p className="">Hết hạn: {formatDateTime(storeData?.es_hsm_token_expired_at)}</p>
        </div>
      </div>
    </div>
    <div className="col-12 col-md-6 col-lg-4 mb-2">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title mb-3">
            Hỗ trợ báo cáo thuế
          </h5>
          <p className="mb-0">Đăng ký: {formatDateTime(storeData?.tax_sv_registed_at)}</p>
          <p className="">Hết hạn: {formatDateTime(storeData?.tax_sv_expired_at)}</p>
        </div>
      </div>
    </div>
  </div>

}
export default SvExpiresBlock;